import { CartDraftPanel } from './CartDraftPanel'

/** Legacy full-page cart (non-pivot). Pivot uses RequestScreen → CartDraftPanel. */
export const CartScreen = () => <CartDraftPanel />
